import { axiosGetCall, axiosPostCall } from './axiosCall';

// API endpoint for getting product-wise machine order count
export const getProductWiseMachineOrderCount = async () => {
  try {
    const response = await axiosGetCall({
      apiEndPoint: 'Order/GetProductWiseMachineOrderCount',
      header: {
        accept: 'text/plain',
      },
    });
    return response;
  } catch (error) {
    console.error('Error fetching product-wise order count:', error);
    throw error;
  }
};

// API endpoint for getting top selling products monthly
export const getTopSellingProductsMonthly = async (startDate, endDate) => {
  try {
    const response = await axiosGetCall({
      apiEndPoint: `Order/GetTopSellingProductsMonthly?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
      header: {
        accept: 'text/plain',
      },
    });
    return response;
  } catch (error) {
    console.error('Error fetching top selling products monthly:', error);
    throw error;
  }
};

// API endpoint for getting dashboard statistics
export const getDashboardStats = async () => {
  try {
    const response = await axiosGetCall({
      apiEndPoint: 'Company/GetDashboardStats',
      header: {
        accept: 'text/plain',
      },
    });
    return response;
  } catch (error) {
    console.error('Error fetching dashboard stats:', error);
    throw error;
  }
};

// API endpoint for getting confirmed order count
export const getConfirmedOrderCount = async () => {
  try {
    const response = await axiosPostCall({
      apiEndPoint: 'Order/GetConfirmedOrderCount',
      body: {},
      header: {
        accept: 'text/plain',
      },
    });
    return response;
  } catch (error) {
    console.error('Error fetching confirmed order count:', error);
    throw error;
  }
};

// API endpoint for getting confirmed order and unapproved user count
export const getConfirmedOrderAndUnApprovedUserCount = async () => {
  try {
    const response = await axiosGetCall({
      apiEndPoint: 'Order/GetConfirmedOrderAndUnApprovedUserCount',
      header: {
        accept: 'text/plain',
      },
    });
    return response;
  } catch (error) {
    console.error(
      'Error fetching confirmed order and unapproved user count:',
      error,
    );
    throw error;
  }
};

// API endpoint for getting top selling companies
export const getTopSellingCompanies = async (startDate, endDate) => {
  try {
    const response = await axiosGetCall({
      apiEndPoint: `Company/GetTopSellingCompanies?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
      header: {
        accept: 'text/plain',
      },
    });
    return response;
  } catch (error) {
    console.error('Error fetching top selling companies:', error);
    throw error;
  }
};

// API endpoint for getting monthly sales data
export const getMonthlySales = async () => {
  try {
    const response = await axiosGetCall({
      apiEndPoint: 'Company/GetMonthlySales',
      header: {
        accept: 'text/plain',
      },
    });
    return response;
  } catch (error) {
    console.error('Error fetching monthly sales:', error);
    throw error;
  }
};

// Helper function to generate date ranges for the last 12 months
export const generateMonthlyDateRanges = () => {
  const ranges = [];
  const now = new Date();

  for (let i = 0; i < 12; i++) {
    const targetMonth = now.getMonth() - i;
    const targetYear = now.getFullYear();

    // Start date: 1st of the month
    const startDate = new Date(targetYear, targetMonth, 1);

    // End date: Last day of the month (30th or 31st)
    const endDate = new Date(targetYear, targetMonth + 1, 0);

    ranges.push({
      month: endDate.toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric',
      }),
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      monthIndex: i,
    });
  }

  return ranges; // Return with current month first (no reverse)
};
